import {
  IconBuildingBridge,
  IconCircleDot,
  IconDropletHalf2,
  IconHexagons,
  IconKeyframes,
  IconTarget,
  IconViewportWide,
  IconWash,
} from '@tabler/icons-react';
import { Text } from '@mantine/core';
import styles from './mapkey.module.css';

const sudsKeyList = [
  {
    icon: <IconTarget />,
    label: 'Source Control',
  },
  {
    icon: <IconBuildingBridge />,
    label: 'Swales & Conveyance Channels',
  },
  {
    icon: <IconKeyframes style={{ transform: 'rotate(90deg)' }} />,
    label: 'Infiltration',
  },
  {
    icon: <IconHexagons />,
    label: 'Filtration',
  },
  {
    icon: <IconWash />,
    label: 'Retention & Detention',
  },
  {
    icon: <IconDropletHalf2 />,
    label: 'Wetlands',
  },
  {
    icon: <IconViewportWide />,
    label: 'Inlets, Outlets, Control',
  },
];

const sudsKeyItems = sudsKeyList.map((item, index) => (
  <li key={index} className={styles.keyItem}>
    <span className={`${styles.circleBackground} ${styles.sudsIcons} `}>{item.icon}</span>
    <Text size="xs">{item.label}</Text>
  </li>
));

export default function MapKey() {
  return (
    <div>
      <ul className={styles.keyItems}>
        <li className={styles.keyItem}>
          <span>
            <div className={styles.catchmentIcon} />
          </span>
          <Text size="xs">Catchment Boundaries</Text>
        </li>
        <hr className={styles.divider} />
        <li className={styles.keyItem}>
          <span className={`${styles.circleBackground} ${styles.csoLocationIcon} `}>
            <IconCircleDot />
          </span>
          <Text size="xs">CSO Location</Text>
        </li>
        <li className={styles.keyItem}>
          <span className={`${styles.circleBackground} ${styles.csoDischargingLocationIcon} `}>
            <IconCircleDot />
          </span>
          <Text size="xs">CSO Location: Discharging</Text>
        </li>
        <hr className={styles.divider} />
        {sudsKeyItems}
      </ul>
    </div>
  );
}
